import type { IBandAxisTheme } from '../../../../../component/axis';

export const axisBand: IBandAxisTheme = {
  domainLine: {
    visible: true
  },
  grid: {
    visible: false
  },
  subGrid: {
    visible: false
  },
  tick: {
    visible: true
  },
  subTick: {
    visible: false
  }
};
